<template>
  <HeaderHome :user="$store.state.user.prenom" />
  <div class="background">

    <!-- En-tête -->
    <div class="page-header">
      <div class="page-header-left">
        <div>
          <p class="page-label">Gestion</p>
          <h2 class="page-title">Transfert élève</h2>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn btn-secondary" @click="createSolde">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          Générer
        </button>
        <template v-if="generer">
          <button class="btn btn-primary" @click="createUser" v-if="!loadBtn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
            Valider
          </button>
          <button class="btn btn-primary" v-else disabled>
            <i class="fa fa-spinner fa-spin"></i> Valider
          </button>
        </template>
      </div>
    </div>

    <!-- Contenu principal -->
    <div class="content">

      <!-- Colonne gauche -->
      <div class="col-left">

        <!-- Informations élève -->
        <div class="card">
          <p class="card-title">Informations élève</p>

          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Nom <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Nom" v-model="form.nom" />
            </div>
            <div class="field-group">
              <label class="field-label">Prénom <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Prénom" v-model="form.prenom" />
            </div>
          </div>

          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Date de naissance <span class="required">*</span></label>
              <input type="date" class="field-input" v-model="form.naiss" />
            </div>
            <div class="field-group">
              <label class="field-label">Mail <span class="required">*</span></label>
              <input type="email" class="field-input" placeholder="email@exemple.fr" v-model="form.mail" />
            </div>
          </div>

          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Téléphone <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Téléphone" v-model="form.tel" />
            </div>
            <div class="field-group">
              <label class="field-label">Code chez nous <span class="required">*</span></label>
              <select class="field-input" v-model="form.code">
                <option value="">Sélectionner</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>
            </div>
          </div>

          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Boîte de vitesse <span class="required">*</span></label>
              <select class="field-input" v-model="form.boite" @change="changeBoite">
                <option value="">Sélectionner</option>
                <option value="BA">BA — Boîte automatique</option>
                <option value="BM">BM — Boîte manuelle</option>
              </select>
            </div>
            <div class="field-group">
              <label class="field-label">Options</label>
              <div class="checkbox-row">
                <label class="checkbox-label">
                  <input type="checkbox" v-model="form.acc" />
                  <img src="../../assets/images/conduite/eclair.png" class="option-img" alt="ACC" />
                  ACC
                </label>
                <label class="checkbox-label">
                  <input type="checkbox" v-model="form.aac" />
                  <img src="../../assets/images/conduite/aac.png" class="option-img" alt="AAC" />
                  AAC
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Solde -->
        <div class="card">
          <p class="card-title">Solde</p>

          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Paiement <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Paiement" @change="setPaiement" v-model="solde.paiement" />
            </div>
            <div class="field-group">
              <label class="field-label">Montant solde <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Solde" v-model="solde.montant" />
            </div>
          </div>

          <button class="btn btn-outline" @click="showAide()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            {{ solde.showAide ? 'Annuler aide' : '+ Aide' }}
          </button>

          <!-- Formulaire aide -->
          <div class="aide-form" v-if="solde.showAide">
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Type d'aide</label>
                <select class="field-input" v-model="solde.aide.type">
                  <option value="CPF">CPF</option>
                  <option value="PE">PE</option>
                  <option value="CFA">CFA</option>
                </select>
              </div>
              <div class="field-group">
                <label class="field-label">N° dossier</label>
                <input type="text" class="field-input" placeholder="Numéro de dossier" v-model="solde.aide.numDossier" />
              </div>
            </div>
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Montant initial</label>
                <input type="text" class="field-input" placeholder="Initial" v-model="solde.aide.ini" />
              </div>
              <div class="field-group">
                <label class="field-label">Déjà payé</label>
                <input type="text" class="field-input" placeholder="Payé" v-model="solde.aide.paye" />
              </div>
              <div class="field-group">
                <label class="field-label">Résultat</label>
                <div class="field-result">{{ parseInt(solde.aide.ini) - parseInt(solde.aide.paye) || '—' }}</div>
              </div>
            </div>
            <button class="btn btn-primary" @click="setAide">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              Valider l'aide
            </button>
          </div>

          <!-- Liste aides -->
          <div class="aides-list" v-if="aides.length !== 0">
            <div class="aide-item" v-for="a in aides" :key="a.id">
              <span class="aide-badge">{{ a.aide }}</span>
              <span class="aide-text">{{ a.initial }} − {{ a.paiement }} = <strong>{{ a.resultat }}</strong></span>
              <span class="aide-num">{{ a.num }}</span>
              <button class="btn-delete" @click="deleteAide(a)">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
          </div>
        </div>

      </div>

      <!-- Colonne droite -->
      <div class="col-right">

        <div class="card info-card">
          <p class="card-title">Reste</p>
          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Heures</label>
              <input type="text" class="field-input" v-model="reste.heure" />
            </div>
            <div class="field-group">
              <label class="field-label">Examen</label>
              <input type="text" class="field-input" v-model="reste.exam" />
            </div>
          </div>
          <div class="calcul-line">
            ({{ parseInt(reste.heure) || 0 }} + {{ parseInt(reste.exam) || 0 }}) × {{ reste.prixBoite }}€ =
            <strong>{{ (parseInt(reste.heure) + parseInt(reste.exam)) * parseInt(reste.prixBoite) || 0 }}€</strong>
          </div>
        </div>

        <div class="card info-card">
          <p class="card-title">Dossier</p>
          <div class="status-badge" :class="statusClass(dossier.paye)">{{ dossier.paye || '—' }}</div>
        </div>

        <div class="card info-card">
          <p class="card-title">Code</p>
          <div class="status-badge" :class="statusClass(code.paye)">{{ code.paye || '—' }}</div>
        </div>

        <div class="card info-card">
          <p class="card-title">Accéléré</p>
          <div class="status-badge" :class="statusClass(acc.paye)">{{ acc.paye || '—' }}</div>
        </div>

      </div>
    </div>

    <!-- Résultat généré -->
    <div class="card result-card" v-if="generer">
      <p class="card-title">Résultat du transfert</p>
      <p class="calcul-summary">
        Transfert solde :
        <span class="calcul-tag" title="Reste">{{ reste.tot }}</span>
        <template v-if="parseInt(solde.montant) >= 0"> + <span class="calcul-tag" title="Solde">{{ parseInt(solde.montant) }}</span></template>
        <template v-else> − <span class="calcul-tag" title="Solde">{{ Math.abs(parseInt(solde.montant)) }}</span></template>
        <template v-if="dossier.paye === 'non'"> + <span class="calcul-tag" title="Dossier">{{ prixDossier }}</span></template>
        <template v-if="code.paye === 'non'"> + <span class="calcul-tag" title="Code">{{ prixCode }}</span></template>
        <template v-if="acc.paye === 'non'"> + <span class="calcul-tag" title="ACC">{{ prixAcc }}</span></template>
        <template v-if="aides.length !== 0">
          <template v-for="a in aides" :key="a.id"> − <span class="calcul-tag" :title="a.aide">{{ a.resultat }}</span></template>
        </template>
        = <strong class="calcul-total">{{ calcul.transfertConduite }}</strong>
      </p>

      <div class="table-wrap">
        <table>
          <colgroup>
            <col style="width: 18%" />
            <col style="width: 12%" />
            <col style="width: 36%" />
            <col style="width: 10%" />
            <col style="width: 12%" />
            <col style="width: 12%" />
          </colgroup>
          <thead>
            <tr>
              <th>Condition</th>
              <th>Date</th>
              <th>Libellé</th>
              <th>Mode</th>
              <th>C</th>
              <th>D</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in calcul.paiements" :key="p.condition">
              <td>{{ p.condition }}</td>
              <td>{{ p.date }}</td>
              <td>{{ p.libelle }}</td>
              <td>{{ p.mode }}</td>
              <td>{{ p.C }}</td>
              <td>{{ p.D }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="solde-final">Solde final = <strong>{{ calcul.finalSolde }}</strong></p>
    </div>

  </div>
</template>

<script>
import HeaderHome from "@/components/home/HeaderHome.vue";

export default {
  components: {
    HeaderHome,
  },

  data() {
    return {
      prixDossier: 0,
      prixCode: 0,
      prixAcc: 0,
      prixBa: 0,
      prixBm: 0,
      prixDossierCode: 0,
      prixDossierCodeAcc: 0,
      generer: false,
      loadBtn: false,

      form: {
        nom: "", prenom: "", mail: "", naiss: "", tel: "",
        code: "", boite: "", acc: false, aac: false,
      },

      reste: { heure: "", exam: "", prixBoite: 0, tot: 0 },
      dossier: { paye: "" },
      code: { paye: "" },
      acc: { paye: "" },

      solde: {
        paiement: "", montant: "", showAide: false,
        aide: { type: "", ini: "", paye: "", resultat: "", numDossier: "" },
      },

      aides: [],

      calcul: { transfertConduite: 0, paiements: [], finalSolde: 0 },
    };
  },

  mounted() {
    this.getFoncs();
  },

  methods: {

    statusClass(val) {
      if (val === "oui") return "badge-green";
      if (val === "non") return "badge-red";
      if (val === "NA")  return "badge-gray";
      return "";
    },

    createUser() {
      this.loadBtn = true;
      window.api.post(
        "/transfert/eleve/" + this.$store.state.user.agence.id,
        {
          nom: this.form.nom, prenom: this.form.prenom, tel: this.form.tel,
          mail: this.form.mail, boite: this.form.boite,
          paiements: this.calcul.paiements, aac: this.form.aac, naiss: this.form.naiss,
        },
        { headers: { Authorization: "Bearer " + this.$store.state.token } }
      ).then(() => {
        this.loadBtn = false;
        this.form = { nom:"", prenom:"", mail:"", naiss:"", tel:"", code:"", boite:"", acc:false, aac:false };
        this.reste = { heure:"", exam:"", prixBoite:0, tot:0 };
        this.dossier.paye = ""; this.code.paye = ""; this.acc.paye = "";
        this.solde = { paiement:"", montant:"", showAide:false, aide:{ type:"", ini:"", paye:"", resultat:"", numDossier:"" } };
        this.aides = [];
        this.calcul = { transfertConduite:0, paiements:[], finalSolde:0 };
        this.generer = false;
      }).catch(error => console.log(error));
    },

    createSolde() {
      this.calcul.paiements = [];
      const checks = [
        [this.form.nom === "",        "Veuillez saisir le nom"],
        [this.form.naiss === "",       "Veuillez saisir la date de naissance"],
        [this.form.prenom === "",      "Veuillez saisir le prénom"],
        [this.form.mail === "",        "Veuillez saisir le mail"],
        [this.form.tel === "",         "Veuillez saisir le téléphone"],
        [this.form.code === "",        "Veuillez saisir le code"],
        [this.form.boite === "",       "Veuillez saisir la boîte"],
        [this.reste.heure === "",      "Veuillez saisir le nombre d'heures"],
        [this.reste.exam === "",       "Veuillez saisir l'exam dans le reste"],
        [this.solde.paiement === "",   "Veuillez saisir le paiement"],
        [this.solde.montant === "",    "Veuillez saisir le montant du solde"],
      ];
      for (const [cond, msg] of checks) { if (cond) { alert(msg); return; } }

      this.reste.tot = (parseInt(this.reste.heure) + parseInt(this.reste.exam)) * this.reste.prixBoite;
      this.calcul.transfertConduite = this.reste.tot + parseInt(this.solde.montant);

      const d = new Date();
      const dateFormatee = `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;

      if (this.dossier.paye === "non") {
        this.calcul.transfertConduite += this.prixDossier;
      } else if (this.dossier.paye === "oui") {
        this.calcul.paiements.push({ condition:"DOSSIER PAYE", date:dateFormatee, libelle:"dossier", mode:"T", C:this.prixDossier, D:this.prixDossier });
      }

      if (this.code.paye === "non") {
        this.calcul.transfertConduite += this.prixCode;
      } else if (this.code.paye === "oui") {
        this.calcul.paiements.push({ condition:"CODE PAYE", date:dateFormatee, libelle:"code", mode:"T", C:this.prixCode, D:this.prixCode });
      }

      if (this.acc.paye === "non") {
        this.calcul.transfertConduite += this.prixAcc;
      } else if (this.acc.paye === "oui") {
        this.calcul.paiements.push({ condition:"ACC PAYE", date:dateFormatee, libelle:"permis accéléré", mode:"T", C:this.prixAcc, D:this.prixAcc });
      }

      let allAideMontant = 0;
      this.aides.forEach(a => {
        allAideMontant += a.resultat;
        this.calcul.transfertConduite -= a.resultat;
        this.calcul.paiements.push({ condition:a.aide, date:dateFormatee, libelle:"Droits " + a.aide, mode:"T", C:a.resultat, D:"" });
      });

      this.calcul.finalSolde = allAideMontant + this.calcul.transfertConduite;
      this.calcul.paiements.push({ condition:"", date:dateFormatee, libelle:"Transfert Solde", mode:"T", C:this.calcul.transfertConduite, D:"" });
      this.generer = true;
    },

    deleteAide(a) {
      this.aides = this.aides.filter(e => a.id !== e.id);
    },

    setAide() {
      if (this.solde.aide.type === "")         { alert("Veuillez saisir le type d'aide"); return; }
      if (this.solde.aide.ini === "")          { alert("Veuillez saisir le montant initial"); return; }
      if (this.solde.aide.paye === "")         { alert("Veuillez saisir le montant payé"); return; }
      if (this.solde.aide.numDossier === "")   { alert("Veuillez saisir le numéro de dossier"); return; }
      this.solde.aide.resultat = parseInt(this.solde.aide.ini) - parseInt(this.solde.aide.paye);
      this.aides.push({ id: this.aides.length + 1, aide: this.solde.aide.type, initial: parseInt(this.solde.aide.ini), paiement: parseInt(this.solde.aide.paye), resultat: this.solde.aide.resultat, num: this.solde.aide.numDossier });
      this.showAide();
    },

    showAide() {
      this.solde.showAide = !this.solde.showAide;
      this.solde.aide = { type:"", ini:"", paye:"", resultat:"", numDossier:"" };
    },

    setPaiement() {
      if (parseInt(this.solde.paiement) < this.prixDossier) {
        this.dossier.paye = "non";
        this.code.paye = this.form.code === "non" ? "NA" : "non";
        this.acc.paye  = this.form.acc === false  ? "NA" : "non";
      } else if (this.prixDossier <= this.solde.paiement && parseInt(this.solde.paiement) < this.prixDossierCode) {
        this.dossier.paye = "oui";
        this.code.paye = this.form.code === "non" ? "NA" : "non";
        this.acc.paye  = this.form.acc === false  ? "NA" : "non";
      } else if (this.prixDossierCode <= this.solde.paiement && parseInt(this.solde.paiement) < this.prixDossierCodeAcc) {
        this.dossier.paye = "oui";
        this.code.paye = this.form.code === "non" ? "NA" : "oui";
        this.acc.paye  = this.form.acc === false  ? "NA" : "non";
      } else if (parseInt(this.solde.paiement) >= this.prixDossierCodeAcc) {
        this.dossier.paye = "oui";
        this.code.paye = this.form.code === "non" ? "NA" : "oui";
        this.acc.paye  = this.form.acc === false  ? "NA" : "oui";
      } else {
        this.dossier.paye = "";
        this.code.paye = "";
        this.acc.paye = "";
      }
    },

    changeBoite(e) {
      this.setPrixBoite(e.target.value);
    },

    setPrixBoite(boite) {
      this.reste.prixBoite = boite === "BA" ? this.prixBa : this.prixBm;
    },

    getFoncs() {
      window.api.get("/transfert/fonc/", {
        headers: { Authorization: "Bearer " + this.$store.state.token },
      }).then(response => {
        this.prixDossier        = response.data.dossier;
        this.prixCode           = response.data.code;
        this.prixAcc            = response.data.prixAcc;
        this.prixBa             = response.data.ba;
        this.prixBm             = response.data.bm;
        this.prixDossierCode    = response.data.dossierCode;
        this.prixDossierCodeAcc = response.data.dossierCodeAcc;
      }).catch(error => console.log(error));
    },
  },
};
</script>

<style scoped>

/* ── Page ── */
.background {
  min-height: 100vh;
  background: #f4f6f9;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── En-tête ── */
.page-header {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  gap: 16px;
}

.page-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.page-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  text-align: left;
}

.page-title {
  margin: 2px 0 0;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  text-align: left;
}

.header-actions {
  display: flex;
  gap: 10px;
}

/* ── Layout contenu ── */
.content {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.col-left {
  flex: 1 1 60%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

.col-right {
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Cartes ── */
.card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.card-title {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #94a3b8;
}

.info-card {
  gap: 10px;
}

.result-card {
  gap: 16px;
}

/* ── Champs ── */
.field-row {
  display: flex;
  gap: 14px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.field-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.18s, background 0.18s;
  appearance: auto;
}

.field-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
}

.field-input::placeholder {
  color: #cbd5e1;
}

.field-result {
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  background: #f1f5f9;
}

/* ── Checkboxes ── */
.checkbox-row {
  display: flex;
  gap: 20px;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #1e293b;
  cursor: pointer;
  accent-color: #3b82f6;
}

.option-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* ── Aide form ── */
.aide-form {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Liste aides ── */
.aides-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.aide-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #f1f5f9;
  border-radius: 10px;
  font-size: 13px;
}

.aide-badge {
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  text-transform: uppercase;
  flex-shrink: 0;
}

.aide-text {
  flex: 1;
  color: #334155;
}

.aide-num {
  color: #94a3b8;
  font-size: 12px;
}

.btn-delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: #fee2e2;
  color: #dc2626;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}

.btn-delete:hover {
  background: #fecaca;
}

/* ── Statut badges ── */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.badge-green { background: #dcfce7; color: #15803d; }
.badge-red   { background: #fee2e2; color: #dc2626; }
.badge-gray  { background: #f1f5f9; color: #94a3b8; }

/* ── Calcul ── */
.calcul-line {
  font-size: 13px;
  color: #64748b;
  padding: 6px 0;
}

.calcul-line strong {
  color: #1e293b;
}

.calcul-summary {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.8;
}

.calcul-tag {
  display: inline-block;
  background: #f1f5f9;
  color: #334155;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 6px;
  font-size: 13px;
}

.calcul-total {
  font-size: 15px;
  color: #1e293b;
}

.solde-final {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  padding-top: 4px;
  border-top: 1px solid #f1f5f9;
}

/* ── Table ── */
.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

thead tr {
  background: #f8fafc;
}

th {
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

td {
  padding: 10px 14px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}

tbody tr:hover {
  background: #f8fafc;
}

/* ── Boutons ── */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-primary {
  background: #3b82f6;
  color: #ffffff;
}

.btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.btn-secondary {
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #e2e8f0;
}

.btn-secondary:hover {
  background: #e2e8f0;
}

.btn-outline {
  background: transparent;
  color: #3b82f6;
  border: 1px solid #3b82f6;
  padding: 7px 14px;
  font-size: 12px;
  align-self: flex-start;
}

.btn-outline:hover {
  background: #eff6ff;
}

</style>
